import React, { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'

interface ConfirmProps {
  header: string
  content: ReactNode
  cancelButtonLabel: string
  confirmButtonLabel: string
  onClose: () => void
  onConfirm: () => void
}

/**
 * Utility component mainly used for a simple confirmation step across the app
 * This component ultimately serves as a replacement for `Confirm` in React
 * world. This is going to evolve as we go through migration.
 */
export const ConfirmationModal: React.FC<ConfirmProps> = ({
  header,
  content,
  cancelButtonLabel,
  confirmButtonLabel,
  onClose,
  onConfirm,
}) => {
  return createPortal(
    <Modal onClose={onClose}>
      <ModalHeader>{header}</ModalHeader>
      <ModalContent>{content}</ModalContent>
      <ModalActions>
        <Button
          data-track="cancel-confirmation-modal"
          variant="supplementary"
          onClick={onClose}
        >
          {cancelButtonLabel}
        </Button>
        <Button
          data-track="confirm-confirmation-modal"
          variant="no"
          className="vd-ml1"
          onClick={onConfirm}
        >
          {confirmButtonLabel}
        </Button>
      </ModalActions>
    </Modal>,
    document.body
  )
}
